var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-music",
      class: { edit: _vm.isSelected },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
      }),
      _c("p", { staticClass: "text-finish", on: { click: _vm.finish } }, [
        _vm._v(_vm._s(_vm.$t("dash.post-creator.story.done"))),
      ]),
      _c("i", {
        staticClass: "fa-solid fa-trash trash",
        on: { click: _vm.deleteMusic },
      }),
      _c(
        "div",
        { staticClass: "sticker sticker-music" },
        [
          _vm.stickerInstance.data.styleVariant
            ? [
                _vm.stickerInstance.data.styleVariant == 1
                  ? _c("div", { staticClass: "card-style" }, [
                      _c("img", {
                        staticClass: "selectDisable",
                        attrs: {
                          src: _vm.stickerInstance.data.music.track
                            ? _vm.stickerInstance.data.music.track
                                .cover_artwork_thumbnail_uri
                            : _vm.stickerInstance.data.music.original_sound
                                .ig_artist.profile_pic_url,
                          alt: "",
                          draggable: "false",
                        },
                      }),
                      _c("div", { staticClass: "info-music" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stickerInstance.data.music.track
                                ? _vm.stickerInstance.data.music.track.title
                                : _vm.stickerInstance.data.music.original_sound
                                    .original_audio_title
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stickerInstance.data.music.track
                                ? _vm.stickerInstance.data.music.track
                                    .display_artist
                                : _vm.stickerInstance.data.music.original_sound
                                    .ig_artist.full_name
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm.stickerInstance.data.styleVariant == 2
                  ? _c("div", { staticClass: "square-style" }, [
                      _c("div", { staticClass: "image" }, [
                        _c("img", {
                          staticClass: "selectDisable",
                          attrs: {
                            src: _vm.stickerInstance.data.music.track
                              ? _vm.stickerInstance.data.music.track
                                  .cover_artwork_thumbnail_uri
                              : _vm.stickerInstance.data.music.original_sound
                                  .ig_artist.profile_pic_url,
                            alt: "",
                            draggable: "false",
                          },
                        }),
                        _c("div", { staticClass: "sound-effect" }),
                      ]),
                      _c("div", { staticClass: "info-music" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stickerInstance.data.music.track
                                ? _vm.stickerInstance.data.music.track.title
                                : _vm.stickerInstance.data.music.original_sound
                                    .original_audio_title
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stickerInstance.data.music.track
                                ? _vm.stickerInstance.data.music.track
                                    .display_artist
                                : _vm.stickerInstance.data.music.original_sound
                                    .ig_artist.full_name
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm.stickerInstance.data.styleVariant == 3
                  ? _c("div", { staticClass: "disc-style" }, [
                      _c("div", { staticClass: "disc" }, [
                        _c("img", {
                          staticClass: "selectDisable",
                          attrs: {
                            src: _vm.stickerInstance.data.music.track
                              ? _vm.stickerInstance.data.music.track
                                  .cover_artwork_thumbnail_uri
                              : _vm.stickerInstance.data.music.original_sound
                                  .ig_artist.profile_pic_url,
                            alt: "",
                            draggable: "false",
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "info-music" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stickerInstance.data.music.track
                                ? _vm.stickerInstance.data.music.track.title
                                : _vm.stickerInstance.data.music.original_sound
                                    .original_audio_title
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stickerInstance.data.music.track
                                ? _vm.stickerInstance.data.music.track
                                    .display_artist
                                : _vm.stickerInstance.data.music.original_sound
                                    .ig_artist.full_name
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm.isSelected
        ? _c(
            "div",
            { staticClass: "container-options" },
            [
              false
                ? _c(
                    "div",
                    { staticClass: "styles" },
                    _vm._l(
                      ["empty", "card", "square", "disc"],
                      function (value, index) {
                        return _c("div", {
                          class: [
                            "style",
                            `${value}-style`,
                            {
                              active:
                                index == _vm.stickerInstance.data.styleVariant,
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.changeStyleVariant(index)
                            },
                          },
                        })
                      }
                    ),
                    0
                  )
                : _vm._e(),
              _c("CursorMusic", {
                attrs: {
                  music: _vm.stickerInstance.data.music,
                  defaultRangeDuration: _vm.stickerInstance.duration,
                  defaultStart: _vm.stickerInstance.data.start,
                  durationLock: !_vm.stickerInstance.durationIsEditable
                    ? _vm.stickerInstance.duration
                    : null,
                },
                on: {
                  rangeDurationChange: function ($event) {
                    _vm.stickerInstance.data.duration = parseInt($event)
                  },
                  startChange: function ($event) {
                    _vm.stickerInstance.data.start = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }